module.exports = __webpack_public_path__ + "static/media/card-holidays-bg.54c280a4.png";